import gql from 'graphql-tag';

import type * as Generated from '../../generated/graphql';
import {useQuery} from './query';

export const MULTI_RUN_WORKSPACE_QUERY = gql`
  query MultiRunWorkspace($projectName: String!, $entityName: String) {
    project(name: $projectName, entityName: $entityName) {
      id
      readOnly
    }
  }
`;

export interface MultiRunWorkspaceQueryData {
  project: {
    id: string;
    readOnly: boolean;
  };
}
export function useMultiRunWorkspaceQuery(
  variables: Generated.MultiRunWorkspaceQueryVariables
) {
  return useQuery<MultiRunWorkspaceQueryData, typeof variables>(
    MULTI_RUN_WORKSPACE_QUERY,
    {variables}
  );
}
